import { StoreModule } from '@ngrx/store';
import { RequestsFeatureKey } from './requests-feature-key';
import { requestsReducer } from './requests.reducer';

export * from './requests-feature-key';
export * from './requests.actions';
export * from './requests.effects';
export * from './requests.reducer';
export * from './requests.selectors';

export const RequestsStoreModule = StoreModule.forFeature(
  RequestsFeatureKey,
  requestsReducer
);
